import React, { useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';

export const SyncGlobalWorker: React.FC = () => {
  const { user } = useAuth();
  const { t } = useTranslation();

  useEffect(() => {
    if (!user) return;

    const syncWorkouts = async () => {
      const queueStr = localStorage.getItem('aura_offline_workouts');
      if (!queueStr) return;
      try {
        const queue: any[] = JSON.parse(queueStr);
        if (queue.length === 0) return;

        console.log(`[SyncWorker] Syncing ${queue.length} offline workouts...`);
        let syncedCount = 0;
        const failedQueue = [];

        for (const workout of queue) {
          const { error } = await supabase.from('workout_logs').insert(workout);
          if (error) {
            console.error(`[SyncWorker] Failed to sync workout ${workout.title}:`, error);
            failedQueue.push(workout);
          } else {
            syncedCount++;
          }
        }

        if (failedQueue.length > 0) {
          localStorage.setItem('aura_offline_workouts', JSON.stringify(failedQueue));
        } else {
          localStorage.removeItem('aura_offline_workouts');
        }

        if (syncedCount > 0) {
           toast.success(t('sync.workouts_synced', { count: syncedCount, defaultValue: `¡${syncedCount} entrenos sincronizados en la nube!` }));
        }

      } catch (e) {
        console.error("[SyncWorker] Error syncing workouts:", e);
      }
    };

    const syncHabits = async () => {
      const queueStr = localStorage.getItem('aura_offline_habits');
      if (!queueStr) return;
      try {
        const queue: any[] = JSON.parse(queueStr);
        if (queue.length === 0) return;

        console.log(`[SyncWorker] Syncing ${queue.length} offline habit days...`);
        let syncedCount = 0;
        const failedQueue = [];

        for (const habitDay of queue) {
          const { error } = await supabase.from('user_habits').upsert({
              user_id: habitDay.user_id,
              date: habitDay.date,
              habits: habitDay.habits
          }, { onConflict: 'user_id,date' });

          if (error) {
            console.error(`[SyncWorker] Failed to sync habit ${habitDay.date}:`, error);
            failedQueue.push(habitDay);
          } else {
            syncedCount++;
          }
        }

        if (failedQueue.length > 0) {
          localStorage.setItem('aura_offline_habits', JSON.stringify(failedQueue));
        } else {
          localStorage.removeItem('aura_offline_habits');
        }
      } catch (e) {
        console.error("[SyncWorker] Error syncing habits:", e);
      }
    };

    const runSync = () => {
        if (navigator.onLine) {
            syncWorkouts();
            syncHabits();
        }
    };

    // Run on mount in case we booted with internet
    runSync();

    // Run when connection is restored
    window.addEventListener('online', runSync);

    // Periodic check (every 5 minutes) as fallback
    const interval = setInterval(runSync, 300000);

    return () => {
      window.removeEventListener('online', runSync);
      clearInterval(interval);
    };
  }, [user]);

  return null;
};
